import type { WebUser } from "@/types/WebUser";
import { pointsToYen } from "@/utils/pointsToYen";
import { ThumbaTrophyIcon } from "@roman/shared/components/Icons";

export const RedeemablePointsHeader = ({ user }: { user: WebUser }) => {
  const yen = pointsToYen(user.redeemablePoints);
  const yenNumber = Number(yen.replace(/,/g, ""));
  const textSize =
    yenNumber >= 10000000 ? "text-xs md:text-base" : yenNumber >= 100000 ? "text-sm md:text-base" : "text-base";
  return (
    <div className="gap-2 h-8 py-1 px-1.5 bg-gray font-bold flex justify-center items-center rounded-full">
      <ThumbaTrophyIcon className="min-w-6 min-h-6" />
      <span className={`${textSize} text-black text-base font-semibold`}>{yen}</span>
    </div>
  );
};
